import { Component, EventEmitter, Injector, Input, OnInit, Output, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DataStateChangeEvent, GridComponent } from '@progress/kendo-angular-grid';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app-core/services/common.service';
import { MaterialService } from 'src/app/material/material.service';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { CommonDataModel } from '../common-data-model';
import { CustomPattern } from 'src/app-core/pattern/custom-pattern';
import { BoxContainerService } from 'src/app/box-container/box-container.service';
import * as _ from 'lodash';
import { MaterialCategoryEnum, MaterialComponentNameEnum } from '../app-common-enum';
import { finalize } from 'rxjs/operators';
const hasClass = (el, className) => new RegExp(className).test(el.className);
const isChildOf = (el, className) => {
    while (el && el.parentElement) {
        if (hasClass(el.parentElement, className)) {
            return true;
        }
        el = el.parentElement;
    }
    return false;
};

@Component({
    selector: 'app-orders-material-grid',
    templateUrl: './orders-material-grid.component.html',
    styleUrls: ['./orders-material-grid.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class OrdersMaterialGridComponent extends AppComponentBase implements OnInit {

    @ViewChild('grid', { static: true }) private grid: GridComponent;
    @ViewChild('materialForm', { static: false }) materialForm: NgForm;
    @Input() IsAddForm: boolean;
    @Input() isExpanded: any;
    @Input() readOnly: boolean;
    @Input() isContainerSummryOpen: any;
    @Input() set containerIdParam(container: any) {
        if (container) {
            this.itemContainerId = container.itemContainerId ? container.itemContainerId : container.baseContainerId;
            this.baseContainerId = container.baseContainerId;
            this.parentContainerId = container.parentContainerId;
            this.initialLoad = container.initialLoad;
            this.isModiAndStructure = container.isModiAndStructure;
            this.isInitialValChanged = container.isInitialValChanged;
            this.templateContainerId = container.templateContainerId;
            this.selectedModifierId = container.selectedModifierId;
        }
        this.onRefreshGridData(0);
    }
    @Input() isStockContainer: boolean;
    @Input() materialTitle: any;
    @Output() emitEnableSaveButton: EventEmitter<any> = new EventEmitter();
    @Output() collapseEmit: EventEmitter<any> = new EventEmitter();
    @Output() onEmitChildBusy: EventEmitter<any> = new EventEmitter();
    materialCategoryEnum: typeof MaterialCategoryEnum = MaterialCategoryEnum;
    materialComponentNameEnum: typeof MaterialComponentNameEnum = MaterialComponentNameEnum;
    commonDataModel = new CommonDataModel();
    facesListWithoutStock: Array<any>;
    gridItems: any = [];
    itemContainerId: any;
    baseContainerId: any;
    templateContainerId: any;
    selectedModifierId: any;
    parentContainerId: number;
    isNew: boolean;
    editedRowIndex: number;
    materialId = 1;
    defaultMaterialsList: Array<any>;
    facesList: Array<any>;
    categories: Array<any>;
    pattern = new CustomPattern();
    materialHeading: string;
    initialGrid: any;
    initialLoad: boolean;
    isModiAndStructure: boolean;
    isInitialValChanged: boolean;
    initialData: any;
    lastEditedIndex: number;

    constructor(
        injector: Injector,
        private toastr: ToastrService,
        private boxContainerService: BoxContainerService,
        private materialService: MaterialService,
        private renderer: Renderer2,
        private commonService: CommonService) {
        super(injector);
        this.renderer.listen(
            'document',
            'click',
            ({ target }) => {
                if (!isChildOf(target, `materialGrid_${this.itemContainerId}`)) {
                    if (this.materialForm.valid) {
                        this.grid.closeRow(this.editedRowIndex);
                        this.emitEnableSaveButton.emit();
                    }
                }
            });
    }

    ngOnInit() {
        this.materialHeading = this.materialTitle;
        this.getFaces();
        this.getCategories();
        this.getDefaultMaterials();
    }

    openAccordian(open: string, state: boolean) {
        if (open) {
            this.isExpanded = state;
            this.collapseEmit.emit();
        }
    }

    closeAccordian(open: string, state: boolean) {
        if (close) {
            this.isExpanded = state;
            this.collapseEmit.emit();
        }
    }

    getDefaultMaterials(dataItem?: any, material?: any) {
        this.commonService.getCleatsList('').subscribe(response => {
            if (response.isSuccess) {
                const materialCategoryList = response.data.find(x => dataItem ? x.materialCategoryId == material.id : true);
                this.defaultMaterialsList = response.data;
                if (dataItem) {
                    dataItem.materialCategoryId = material.id;
                    if (materialCategoryList) {
                        dataItem.materialId = materialCategoryList.id;
                        this.updateDimensionToItem(dataItem);
                    } else {
                        this.toastr.warning('No Materials Found for the Material Category');
                        dataItem.materialId = null;
                    }
                }
            }
        });
    }

    onDefaultMaterialsListFIltered(data: any) {
        if (this.defaultMaterialsList) {
            return this.defaultMaterialsList.filter(item => item.materialCategoryId == data.materialCategoryId);
        }
    }

    getFaces() {
        this.boxContainerService.getFaceLookups().subscribe(response => {
            this.facesList = response.data;
            this.facesListWithoutStock = response.data.filter(item => !item.isReadOnly);
        });
    }

    getCategories(): void {
        this.materialService.getCategories().subscribe(response => {
            if (response.isSuccess) {
                this.categories = response.data;
            }
        });
    }

    onMaterialChange(materialNameChange: any, dataItem: any) {
        dataItem.materialId = materialNameChange.id;
        dataItem.materialName = materialNameChange.materialName;
        dataItem.isChanged = true;
        if (dataItem.initialMaterialId !== dataItem.materialId) {
            dataItem.isMaterialIdChanged = true;
        } else {
            dataItem.isMaterialIdChanged = false;
        }
        this.updateDimensionToItem(dataItem);
    }

    onQuantityChange(quantityChange: any, dataItem: any) {
        dataItem.isChanged = true;
        this.emitEnableSaveButton.emit();
        if (dataItem.initialQuantity !== quantityChange) {
            dataItem.isQuantityChanged = true;
        }
    }

    updateDimensionToItem(dataItem: any): any {
        const tempDataItem = _.cloneDeep(dataItem);
        this.materialService.getMaterialDimension(dataItem.materialId).subscribe(response => {
            response.data.quantity = Math.ceil(response.data.quantity);
            dataItem.defaultQuantity = response.data.quantity;
            dataItem.defaultLength = response.data.length;
            dataItem.defaultWidth = response.data.width;
            dataItem.defaultHeight = response.data.height;
            dataItem.unitWeight = response.data.unitWeight;
            dataItem.defaultWasteFactor = response.data.wasteFactor;
            dataItem.defaultTotalCost = response.data.totalCost;
            this.commonService.objectMapping(dataItem, response.data);
            dataItem.quantity = tempDataItem.quantity;
            dataItem.nonStdLabor = response.data.laborMinutesPer;
            this.materialForm.form.markAsDirty();
            this.emitEnableSaveButton.emit();
            if (dataItem.componentName === this.materialComponentNameEnum.deckBoard) {
                const rickDeckBoardMaterials = this.gridItems.filter(item => item.componentName === this.materialComponentNameEnum.rippedDeckBoard);
                rickDeckBoardMaterials.forEach(mat => {
                    this.commonService.objectMapping(mat, response.data);
                });
            }
        });
    }

    onCategoryOpen(index: number) {
        if (index !== this.editedRowIndex && !this.isStockContainer) {
            if (this.materialForm.valid) {
                this.grid.closeRow(this.editedRowIndex);
                this.editedRowIndex = index;
                this.grid.editRow(index);
            }
        }
    }

    onFacesChange(faceChange: any, dataItem: any) {
        dataItem.faceId = faceChange.id;
        dataItem.faceName = faceChange.faceName;
        dataItem.isChanged = true;
    }

    onCategoryChange(material: any, dataItem: any) {
        dataItem.materialCategoryId = material.id;
        dataItem.defaultMaterialList = this.defaultMaterialsList.filter((s) => s.materialCategoryId == dataItem.materialCategoryId);
        this.getDefaultMaterials(dataItem, material);
    }

    onRefreshGridData(skipCount: number): void {
        this.kendogridHelper.sort = [{ dir: 'asc', field: 'faceName' }];
        this.grid.dataStateChange.emit({
            skip: skipCount,
            take: this.kendogridHelper.defaultRecordsCountPerPage,
            filter: undefined,
            group: undefined,
            sort: this.kendogridHelper.sort,
        });
    }

    getGridRecords(event: DataStateChangeEvent): void {
        if (event) {
            this.kendogridHelper.dataStateChangeEvent(event);
        }
        if (this.itemContainerId) {
            if (!event.sort[0].dir) {
                event.sort[0].dir = 'asc';
                event.sort[0].field = 'faceName';
            }
            if (this.isModiAndStructure && !this.initialLoad && this.isInitialValChanged) {
                if (this.baseContainerId) {
                    let filterQuery = '';
                    //filterQuery = `&baseContainerId=${this.baseContainerId}&ItemContainerId=${this.itemContainerId ? this.itemContainerId : ''}`;
                    filterQuery = `&baseContainerId=${this.baseContainerId}&ItemContainerId=${this.itemContainerId ? this.itemContainerId : ''}
                    &templateContainerId=${this.templateContainerId ? this.templateContainerId : ''}
                    &selectedModifierId=${this.selectedModifierId ? this.selectedModifierId : ''}`;
                    this.kendogridHelper.showLoadingIndicator();
                    this.onEmitChildBusy.emit(true);
                    this.boxContainerService.getMaterialGridRecords(event, '', filterQuery)
                        .pipe(finalize(() => (this.onEmitChildBusy.emit(false)))).subscribe(response => {
                            this.onEmitChildBusy.emit(false);
                            if (response.isSuccess) {
                                response.data.items.map(item => {
                                    item.totalCost = item.totalCost ? item.totalCost.toFixed(2) : 0;
                                    item.defaultWasteFactor = item.wasteFactor;
                                });
                                this.gridItems = response.data.items;
                                this.kendogridHelper.setGridData(response.data);
                                this.kendogridHelper.hideLoadingIndicator();
                            }
                        });
                }
            } else {
                const filterQuery = `&baseContainerId=${this.parentContainerId}&ItemContainerId=${this.itemContainerId ? this.itemContainerId : ''}`;
                this.kendogridHelper.showLoadingIndicator();
                this.commonService.getQuoteMaterialGridRecords(event, '', filterQuery).subscribe(response => {
                    if (response.isSuccess) {
                        response.data.items.map(item => {
                            item.defaultWasteFactor = item.wasteFactor;
                        });
                        this.gridItems = response.data.items;
                        this.kendogridHelper.setGridData(response.data);
                        this.initialGrid = _.cloneDeep(response.data);
                        this.kendogridHelper.hideLoadingIndicator();
                    }
                });
            }
        }
    }

    onAddHandler(): void {
        if (this.materialForm.valid) {
            const DefauldGridData = _.cloneDeep(this.commonDataModel.defauldGridDataModel);
            DefauldGridData.tempId = this.materialId++;
            const topCategory = this.categories[0];
            const defaulMaterial = this.defaultMaterialsList.find(item => item.materialCategoryId === topCategory.id);
            DefauldGridData.materialId = defaulMaterial.id;
            DefauldGridData.materialCategoryId = topCategory.id;
            DefauldGridData.materialName = defaulMaterial.materialName;
            DefauldGridData.defaultWasteFactor = defaulMaterial.wasteFactor;
            DefauldGridData.defaultTotalCost = defaulMaterial.totalCost ? defaulMaterial.totalCost.toFixed(2) : 0;
            DefauldGridData.defaultMaterialList = this.defaultMaterialsList.filter((s) => s.materialCategoryId == DefauldGridData.materialCategoryId);
            if (this.isModiAndStructure) {
                DefauldGridData.baseContainerId = this.parentContainerId ? this.parentContainerId : this.baseContainerId;
                DefauldGridData.modifiersId = this.baseContainerId;
            } else {
                DefauldGridData.baseContainerId = this.baseContainerId;
            }
            this.gridItems.splice(0, 0, DefauldGridData);
            this.updateDimensionToItem(DefauldGridData);
            this.materialForm.form.markAsDirty();
            this.emitEnableSaveButton.emit();
        }
    }

    onDataChanged(dataItem: any) {
        dataItem.isChanged = true;
        this.emitEnableSaveButton.emit();
    }

    newItemsInsertToGrid(customItems: any) {
        if (customItems && customItems.length > 0) {
            const tempCustomItems = Object.assign([], customItems);
            tempCustomItems.forEach((value: { containerMaterialId: any; }) => {
                if (!value.containerMaterialId) {
                    this.gridItems.splice(0, 0, value);
                }
            });
        }
    }

    getMaterials(): any {
        if (this.initialGrid && this.initialGrid.items.length > 0) {
            const deletedItems: Array<any> = [];
            this.initialGrid.items.forEach(material => {
                const currentmaterial = this.gridItems.find(lineitem => lineitem.containerMaterialId == material.containerMaterialId);
                if (!currentmaterial) {
                    material.isActive = false;
                    deletedItems.push(material);
                }
            });
            return _.union(this.gridItems, deletedItems);
        } else {
            return this.gridItems;
        }
    }

    onCellClickHandler({ sender, rowIndex, isEdited }): void {
        if (this.readOnly) return;
        if (!isEdited && !this.isStockContainer) {
            if (this.materialForm.valid) {
                this.grid.closeRow(this.editedRowIndex);
                this.editedRowIndex = rowIndex;
                sender.editRow(rowIndex);
            }
        }
    }

    onRemoveHandler(index: number) {
        if (this.readOnly) return;
        const AddedMaterialList: any = this.grid.data;
        AddedMaterialList.data.splice(index, 1);
        this.materialForm.form.markAsDirty();
        this.emitEnableSaveButton.emit();
    }

    setCleatmaterials(materialId: any) {
        if (this.gridItems.length > 0) {
            this.materialService.getMaterialDimension(materialId).subscribe(response => {
                if (response.isSuccess) {
                    delete response.data.quantity;
                    this.gridItems.forEach(element => {
                        if (element.componentName.toLowerCase().includes('cleat')) {
                            this.commonService.objectMapping(element, response.data);
                        }
                    });
                }
            });
        }
    }

    setplywoodmaterials(materialId: any) {
        if (this.gridItems.length > 0) {
            this.materialService.getMaterialDimension(materialId).subscribe(response => {
                if (response.isSuccess) {
                    delete response.data.quantity;
                    this.gridItems.forEach(element => {
                        if (element.materialCategoryId === this.materialCategoryEnum.plywood && !element.isCustom) {
                            this.commonService.objectMapping(element, response.data);
                        }
                    });
                }
            });
        }
    }

    onReset() {
        this.kendogridHelper.setGridData(_.cloneDeep(this.initialGrid));
    }

    handleFilter(value: any, dataItem: any) {
        dataItem.defaultMaterialList = this.defaultMaterialsList.filter((s) => s.materialCategoryId == dataItem.materialCategoryId && s.materialName.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }
}
